import { NgIf } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Breadcrumb } from '@app/api/core/decorator/breadcrumb.decorator';
import { MainContentComponent } from '@app/shared/components/main-content/main-content.component';
import { MenuCardComponent } from '@app/shared/components/menu-card/menu-card.component';
import { ChecklistItemListComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/components/checklist-item-list/checklist-item-list.component';
import { FormHistoryComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/components/form-history/form-history.component';
import { FormComponent } from '@app/shared/gsm/gsm-ui-lib-elements/src/app/components/form/form.component';
import { SchadenMeldenComponent } from './schaden-melden.component';

@Breadcrumb({
  name: 'Schaden bearbeiten'
})

@Component({
  selector:      'app-schaden-bearbeiten',
  templateUrl:   './schaden-melden.component.html',
  styleUrls:     ['./schaden-melden.component.scss'],
  encapsulation: ViewEncapsulation.None,
  schemas:       [CUSTOM_ELEMENTS_SCHEMA],
  standalone:    true,
  imports:       [
    MainContentComponent,
    NgIf,
    MatCard,
    MatButton,
    FormHistoryComponent,
    FormComponent,
    MatProgressSpinner,
    MenuCardComponent,
    MatIcon,
    ChecklistItemListComponent
  ]
})
export class SchadenBearbeitenComponent extends SchadenMeldenComponent {
}
